function warningBanner () {
  return {
    restrict: 'E',
    scope: {
      text: '@'
    },
    templateUrl: '/admin/directives/warning-banner/warning-banner.html?$$REVISION$$'
  }
}

export { warningBanner }
